import { AppReviewService, LoginService } from '@pxl/models/contracts';
import { ReviewService, UserReviewModel } from '@pxl/shared/generated';
import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';

export class DefaultAppReviewService implements AppReviewService {
    protected readonly reviewBackendService = inject(ReviewService);
    protected readonly loginService = inject(LoginService);
    protected readonly config = inject(CONFIG_TOKEN);

    public doReview(userReviewModel: UserReviewModel): Observable<void> {
        return this.reviewBackendService.doReview(userReviewModel, this.config.API_VERSION, this.loginService.getToken());
    }

    public fetchLastReviewDate(): Observable<Date | null> {
        const lastReview = this.reviewBackendService.getLastReview(this.config.API_VERSION, this.loginService.getToken());

        return lastReview.pipe(map((review) => (review.date ? new Date(review.date) : null)));
    }
}
